import {Grid, Heading, Text} from '@primer/react-brand'
// eslint-disable-next-line import/no-namespace
import * as Octicons from '@primer/octicons-react'

import {ICONS} from '../../svgs'
import type {GitHubAppWaitlistCopy} from '../../Index.data'

import Styles from './Content.module.css'
import {Form, type FormProps} from '../Form/Form'

export interface ContentProps {
  isFormSubmitted: boolean
  content: GitHubAppWaitlistCopy['content']
  form: FormProps['form']
  thankYou: FormProps['thankYou']
}

export const Content = ({isFormSubmitted, content, form, thankYou}: ContentProps) => {
  const {heading, osBadges, features} = content

  return (
    <section className={Styles['Content']}>
      <Grid fullWidth enableGutters={false} className={Styles['Content__grid']}>
        <Grid.Column span={{xsmall: 12, large: 5}} className={Styles['Content__leftColumn']}>
          <div className={Styles['Content__header']}>
            <Heading as="h2" size="3" className={Styles['Content__heading']} weight="normal">
              {heading}
            </Heading>

            <ul className={Styles['Content__osBadges']}>
              {osBadges.map(badge => (
                <li key={badge.label} className={Styles['Content__osBadges-item']} aria-label={badge.label}>
                  {ICONS[badge.iconName]}
                </li>
              ))}
            </ul>
          </div>

          <ul className={Styles['Content__features']}>
            {features.map((feature, index) => {
              const Icon = Octicons[feature.iconName]
              return (
                // eslint-disable-next-line @eslint-react/no-array-index-key
                <li key={`feature-${index}`} className={Styles['Content__features-item']}>
                  <div>
                    <span className={Styles['Content__features-item-icon']}>
                      <Icon size={24} />
                    </span>
                  </div>
                  <div>
                    <Heading as="h3" size="6" className={Styles['Content__features-item-heading']} weight="normal">
                      {feature.heading}
                    </Heading>
                    <Text as="p" className={Styles['Content__features-item-body']} variant="muted">
                      {feature.body}
                    </Text>
                  </div>
                </li>
              )
            })}
          </ul>
        </Grid.Column>

        <Grid.Column span={{xsmall: 12, large: 7}} className={Styles['Content__rightColumn']}>
          <Form isFormSubmitted={isFormSubmitted} form={form} thankYou={thankYou} />
        </Grid.Column>
      </Grid>
    </section>
  )
}
